import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import MosqueList from "./MosqueList";
import {
  Container,
  Box,
  CircularProgress,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { GET_MOSQUES, GET_PREFECTURES } from "./mosqueQueries";
import GeneralHeader from "../common-component/GeneralHeader";
import PrefectureFilter from "../common-component/PrefectureFilter";
import ErrorPage from "../common-component/ErrorPage";

const MosqueLayout = () => {
  const { countryId } = useParams();
  const [offset, setOffset] = useState(0);
  const [selectedPrefectures, setSelectedPrefectures] = useState([]);
  const limit = 15;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setSelectedPrefectures([]);
    setOffset(0);
  }, [countryId]);

  const {
    loading: loadingMosques,
    error: errorMosques,
    data: dataMosques,
  } = useQuery(GET_MOSQUES, {
    variables: {
      country: countryId,
      prefectures: selectedPrefectures,
      limit,
      offset,
    },
  });

  const {
    loading: loadingPrefectures,
    error: errorPrefectures,
    data: dataPrefectures,
  } = useQuery(GET_PREFECTURES, {
    variables: { country: countryId },
  });

  const handleNextPage = () => setOffset(offset + limit);
  const handlePrevPage = () => setOffset(Math.max(offset - limit, 0));

  const handlePrefectureToggle = (prefecture) => {
    setSelectedPrefectures((prev) =>
      prev.includes(prefecture)
        ? prev.filter((item) => item !== prefecture)
        : [...prev, prefecture]
    );
    setOffset(0);
  };

  const isLoading = loadingMosques || loadingPrefectures;
  const error = errorMosques || errorPrefectures;

  return (
    <>
      <GeneralHeader
        heading="Explore Mosques"
        subheading="Find mosques in your area"
      />
      <Container style={{ marginTop: "3%" }}>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <ErrorPage error={error} />
        ) : (
          <Grid container spacing={4}>
            {isMobile && (
              <Grid item xs={12}>
                <PrefectureFilter
                  prefectures={dataPrefectures?.getMosquesPrefectures || []}
                  selectedPrefectures={selectedPrefectures}
                  onToggle={handlePrefectureToggle}
                />
              </Grid>
            )}
            {!isMobile && (
              <Grid item md={3}>
                <PrefectureFilter
                  prefectures={dataPrefectures?.getMosquesPrefectures || []}
                  selectedPrefectures={selectedPrefectures}
                  onToggle={handlePrefectureToggle}
                />
              </Grid>
            )}
            <Grid item xs={12} lg={8} md={isMobile ? 12 : 9}>
              <MosqueList
                mosques={dataMosques?.mosques || []}
                countryId={countryId}
                onNextPage={handleNextPage}
                onPrevPage={handlePrevPage}
                hasMore={dataMosques?.mosques?.length === limit}
                offset={offset}
              />
            </Grid>
          </Grid>
        )}
      </Container>
    </>
  );
};

export default MosqueLayout;
